import React from "react";

const CircularProgressRing = ({ percentage = 0, label = "" }) => {
  const angle = (percentage / 100) * 360;

  return (
    <div style={{borderRadius: " 50%" ,}}>
        <div style={styles.container}>
        <svg width="120" height="120" viewBox="0 0 120 120">
            <circle
            cx="60"
            cy="60"
            r="54"
            stroke="#e5e7eb"
            strokeWidth="12"
            fill="none"
            />
            <circle
            cx="60"
            cy="60"
            r="54"
            stroke="#0048b7"
            strokeWidth="12"
            fill="none"
            strokeDasharray="339.292"
            strokeDashoffset={339.292 - (angle / 360) * 339.292}
            transform="rotate(-90 60 60)"
            />
        </svg>
        <div style={styles.centerText}>
            <div style={{ fontSize: "12px", color: "#6b7280" , lineHeight:'100%'}}>{label}</div>
            <div style={{ fontSize: "24px", fontWeight: "bold" }}>
            {percentage}%
            </div>
        </div>
        </div>               
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    width: "120px",
    height: "120px",
  },
  centerText: {
    width: "70%",
    height: "70%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    padding: "6px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default CircularProgressRing;
